export const GET_KYC_SUCCESS = 'GET_KYC_SUCCESS';
export const SET_KYC_LOADING = 'SET_KYC_LOADING';
